export default __webpack_public_path__ + "static/media/med.02a7980a.png";